import { MenuItem } from '@mode/shared/ui';

export class MatchOnMenuItem implements MenuItem {
  static readonly QUERY: MenuItem = new MatchOnMenuItem({
    name: 'Query',
    value: 'queryKeywords',
  });

  static readonly CONTENT_NAME: MenuItem = new MatchOnMenuItem({
    name: 'Content name',
    value: 'name',
  });

  static readonly CREATOR: MenuItem = new MatchOnMenuItem({
    name: 'Creator',
    value: 'reportCreatorName',
  });

  static readonly DESCRIPTION: MenuItem = new MatchOnMenuItem({
    name: 'Descriptions',
    value: 'description',
  });

  readonly name: MenuItem['name'];
  readonly value: MenuItem['value'];

  constructor({ name, value }: MenuItem) {
    this.name = name;
    this.value = value;
  }

  toString() {
    return this.name;
  }
}
